/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { createUser, safeguardingRecords } from '../../utils/types'

export const calculatePageCount = (dataLength: number): number => {
  if (dataLength < 5) {
    return 1
  } else {
    return Math.ceil(dataLength / 5)
  }
}

export const statusBgColor = (status: string): string => {
  switch (status) {
    case 'active':
      return 'lightGreen'
    case 'archived':
      return 'paleYellow'
    case 'suspended':
      return 'palePink'
    case 'inactive':
      return 'gray3'
    default:
      return 'gray3'
  }
}

interface Item {
  value: string
  label: string
}
export function findLabelByValue(
  valueToFind: string,
  arrayOfObjects: Item[]
): string | null {
  // Loop through the array
  for (let i = 0; i < arrayOfObjects.length; i++) {
    // Check if the current object's value matches the value to find
    if (arrayOfObjects[i].value === valueToFind) {
      // Return the label of the matching object
      return arrayOfObjects[i].label
    }
  }
  // If no match is found, return null or handle appropriately
  return null
}

export const checkValidation = (formData: createUser) => {
  if (
    formData.email == '' ||
    formData.role == '' ||
    formData.firstName == '' ||
    formData.lastName == ''
    // formData.receivedDate== ''
    // formData.receivedBy== ''||

    // formData.supportRequirmentRating== ''||
    // formData.immediateActionTaken== ''||
    // formData.furtherActionRequired== ''||
    // formData.monitoringRequired== ''||
    // formData.conclusionOfOutcome== ''
  ) {
    return true
  } else {
    return false
  }
}

export function getStoredIds(key: string): string[] {
  // Retrieve the JSON string from local storage
  const storedIdsString = localStorage.getItem(key)

  // Parse the JSON string and return it as an array
  if (storedIdsString) {
    try {
      const storedIds = JSON.parse(storedIdsString)

      // Ensure that the parsed data is an array of strings
      if (
        Array.isArray(storedIds) &&
        storedIds.every((id) => typeof id === 'string')
      ) {
        return storedIds
      } else {
        return []
      }
    } catch (error) {
      return []
    }
  }

  // Return an empty array if there's no data in local storage
  return []
}
export const initialData = {
  firstName: '',
  lastName: '',
  email: '',
  role: '',
  sendInvitationEmail: true,
}
export const fileHeaders = [
  { key: 'Name', label: 'Name' },
  { key: 'Role', label: 'Role' },
  { key: 'Profile', label: 'Profile' },
  { key: 'Safeguarding', label: 'Safeguarding' },
  { key: 'Training', label: 'Training' },
  { key: 'Status', label: 'Status' },
  { key: 'addressLineOn', label: 'addressLineOne' },
  { key: 'addressLineOn', label: 'addressLineOne' },
  { key: 'userName', label: 'userName' },
  { key: 'email', label: 'email' },
  { key: 'schoolName', label: 'schoolName' },
  { key: 'role', label: 'role' },
  { key: 'title', label: 'title ' },
  { key: 'firstName', label: 'firstName ' },
  { key: 'lastName', label: 'lastName ' },
  { key: 'dateOfBirth', label: 'dateOfBirth ' },
  { key: 'gender', label: 'gender ' },
  { key: 'ethnicity', label: 'ethnicity ' },
  { key: 'disability', label: 'disability ' },
  { key: 'businessContactNumber', label: 'businessContactNumber ' },
  { key: 'extensionNumber', label: 'extensionNumber ' },
  { key: 'personalContactNumber', label: 'personalContactNumber ' },
  { key: 'businessEmail', label: 'businessEmail ' },
  { key: 'personalEmail', label: 'personalEmail ' },
  { key: 'town', label: 'town ' },
  { key: 'country', label: 'country ' },
  { key: 'postCode', label: 'postCode ' },
  { key: 'e_contact_firstName', label: 'e_contact_contactNumber ' },
  { key: 'e_contact_lastName', label: 'e_contact_lastName ' },
  { key: 'e_contact_contactNumber', label: 'e_contact_contactNumber ' },
  { key: 'e_contact_relationship', label: 'e_contact_relationship ' },
  { key: 'e_contact_addressLineOne', label: 'e_contact_addressLineOne ' },
  { key: 'e_contact_addressLineTwo', label: 'e_contact_addressLineTwo ' },
  { key: 'e_contact_town', label: 'e_contact_town ' },
  { key: 'e_contact_country', label: 'e_contact_country ' },
  { key: 'e_contact_postCode', label: 'e_contact_postCode ' },
]
export const getScrHeaderConfig = (activeTab: string) => [
  {
    heading: 'Name',
    key: 'firstName',
    icon: true,
    display: true,
  },
  {
    heading: 'Role',
    key: 'role',
    icon: true,
    display: true,
  },
  {
    heading: 'Profile',
    key: '',
    icon: false,
    display: true,
  },
  {
    heading: 'Safeguarding',
    key: '',
    icon: false,
    display: true,
  },
  {
    heading: 'Training',
    key: '',
    icon: false,
    display: true,
  },
  {
    heading: 'Status',
    key: 'status',
    icon: true,
    display: activeTab === 'tab2' ? false : true,
  },
]

export type TrainingRecor = {
  trainingId: string
  userId: string
  trainingRecordCategoryId: string
  schoolId: string
  certificateNumber: string
  date: string
  document_verification_status?: 'pending' | 'accepted' | 'rejected'
  reviewDate: string
  verifiedBy: string
  firstName?: string
  verificationDate: string
  riskAssessmentStatus: string
  certificateUrl?: string
  riskDocumentUrl?: string
  duration: string
  certificate: string | null
  riskDocument: string | null
}

export type Comment = {
  comment: string
  commentId: string
  'comments.createdAt': string
  createdBy: string
  firstName: string
}
export type SafeguardingRecor = {
  safeguardId?: string
  safeguardingRecordCategoryId: string
  document_verification_status?: 'pending' | 'accepted' | 'rejected'
  verifiedBy: string
  firstName?: string
  verificationDate: string
  riskAssessmentStatus: string
  duration: string
  issueDate: string
  expiryDate: string
  riskDocument: string
  documentType: string
  documentNo: string
  document: string
  riskDocumentUrl?: string
  documentUrl?: string
}

export function getColumnDataByCategoryId(
  data: TrainingRecor[],
  categoryId: string,
  columnName: keyof TrainingRecor
): (string | null)[] {
  return data
    .filter((record) => record.trainingRecordCategoryId === categoryId)
    .map((record) => record[columnName] || null)
}

export function getSafeguardingColumnDataByCategoryId(
  data: SafeguardingRecor[],
  categoryId: string,
  columnName: keyof SafeguardingRecor
): (string | null | boolean)[] {
  return data
    .filter((record) => record.safeguardingRecordCategoryId === categoryId)
    .map((record) => record[columnName] || null)
}

export // ... existing code ...

const calculateFieldsPercentage = (
  safeguardingCategories: any[],
  safeguardingRecords: any[]
) => {
  let totalFields = 0
  let emptyFields = 0

  safeguardingCategories.forEach((category, index) => {
    const fieldsToCheck = [
      safeguardingRecords && safeguardingRecords[index]
        ? safeguardingRecords[index]?.document
        : '',
      safeguardingRecords && safeguardingRecords[index]
        ? safeguardingRecords[index]?.documentNo
        : '',
      safeguardingRecords && safeguardingRecords[index]
        ? safeguardingRecords[index]?.documentType
        : '',
      safeguardingRecords && safeguardingRecords[index]
        ? safeguardingRecords[index]?.verificationDate
        : '',
      safeguardingRecords && safeguardingRecords[index]
        ? safeguardingRecords[index]?.verifiedBy
        : '',
    ]

    // Conditionally add fields based on item properties
    if (safeguardingRecords && category.riskAssessment) {
      fieldsToCheck.push(
        safeguardingRecords[index]?.riskAssessmentStatus,
        safeguardingRecords[index]?.duration,
        safeguardingRecords[index]?.riskDocument
      )
    }

    if (safeguardingRecords && category.issueDate) {
      fieldsToCheck.push(safeguardingRecords[index]?.issueDate)
    }

    if (safeguardingRecords && category.expiryDate) {
      fieldsToCheck.push(safeguardingRecords[index]?.expiryDate)
    }

    // Count total fields and empty fields
    totalFields += fieldsToCheck.length
    emptyFields += fieldsToCheck.filter((field) => !field).length
  })

  const percentage = Number(
    (totalFields > 0
      ? ((totalFields - emptyFields) / totalFields) * 100
      : 0
    ).toFixed(0)
  )

  return {
    totalFields,
    emptyFields,
    percentage,
  }
}

// ... existing code ...
